import {connect} from 'react-redux';

import MainScore from '../MainScore.jsx';

function select(state, props) {
    const score = state.application.getIn(['live', 'scores', props.scoreId]);

    return {
        ...props,
        score
    };
}

export default connect(select)(MainScore);



// WEBPACK FOOTER //
// ./js/sport-betting/components/menu/live/MainScore.jsx